import * as THREE from 'three';
import Action from '../classes/Action';
import MathUtils from '../classes/utilities/MathUtils';
import ARTracker from '../classes/ARTracker';

export default class SetModelTrackerPoseAction extends Action
{
	constructor(tracker: ARTracker, 
		cameraPosition: THREE.Vector3, oldCameraPosition: THREE.Vector3, 
		cameraRotation: THREE.Euler, oldCameraRotation: THREE.Euler, 
		modelPosition: THREE.Vector3, oldModelPosition: THREE.Vector3,
		modelRotation: THREE.Euler, oldModelRotation: THREE.Euler)
	{
		const actionName = "Edited Object Tracker Pose";

		super([tracker, cameraPosition, cameraRotation, modelPosition, modelRotation],
			[tracker, oldCameraPosition, oldCameraRotation, oldModelPosition, oldModelRotation],
			actionName,
			[cameraPosition, oldCameraPosition, cameraRotation, oldCameraRotation, modelPosition, oldModelPosition, modelRotation, oldModelRotation]);
	}

	do(tracker: ARTracker, cameraPosition: THREE.Vector3, cameraRotation: THREE.Euler, modelPosition: THREE.Vector3, modelRotation: THREE.Euler)
	{
		tracker.modelTrackerCamera.position.copy(cameraPosition);
		tracker.modelTrackerCamera.rotation.copy(cameraRotation);
		tracker.modelPreviewInstance!.position.copy(modelPosition);
		tracker.modelPreviewInstance!.rotation.copy(modelRotation);
		tracker.modelTrackerCamera.userData.renderIsDirty = true;
	}

	verify(cameraPosition: THREE.Vector3, oldCameraPosition: THREE.Vector3, 
		cameraRotation: THREE.Euler, oldCameraRotation: THREE.Euler, 
		modelPosition: THREE.Vector3, oldModelPosition: THREE.Vector3, 
		modelRotation: THREE.Euler, oldModelRotation: THREE.Euler) : boolean
	{
		return (!MathUtils.areVectorsEqual(cameraRotation, oldCameraRotation) || !MathUtils.areVectorsEqual(cameraPosition, oldCameraPosition) ||
				!MathUtils.areVectorsEqual(modelPosition, oldModelPosition) || !MathUtils.areVectorsEqual(modelRotation, oldModelRotation));
	}
}
